import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page53"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "content",
  style: {
    "width": "100%",
    "position": "absolute",
    "top": "7%",
    "transform": "translateY(-50%)"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
import 场景展示 from '@/assets/v2/page5-1/场景展示.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import 图 from '@/assets/v2/page5-5/图.webp';
import wenzi1 from '@/assets/v2/page5-5/文字/wenzi1.webp';
import 沐光 from '@/assets/v2/page5-5/文字/沐光.webp';
import 预留灵活空间 from '@/assets/v2/page5-5/文字/预留灵活空间.webp';
import 成长 from '@/assets/v2/page5-5/文字/成长.webp';
import 竖线1 from '@/assets/v2/page5-1/标识线/竖线1.webp';
import zhexian from '@/assets/v2/page5-5/标识线条/zhexian.webp';
import 椭圆黑 from '@/assets/v2/page5-1/标识线/椭圆黑.webp';
import 阳台推拉门 from '@/assets/v2/page5-5/文字/阳台推拉门.webp';
export default {
  __name: 'Page5-5',
  emits: ['goHome'],
  setup(__props, {
    emit: __emit
  }) {
    // 引入图片
    const emit = __emit;
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(场景展示),
        alt: "场景展示",
        class: "场景展示",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(wenzi1),
        alt: "wenzi1",
        class: "wenzi1",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(zhexian),
        alt: "zhexian",
        class: "zhexian",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑1",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(沐光),
        alt: "沐光",
        class: "沐光",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线2",
        loading: "lazy"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑2",
        loading: "lazy"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        src: _unref(阳台推拉门),
        alt: "阳台推拉门",
        class: "阳台推拉门",
        loading: "lazy"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        src: _unref(图),
        alt: "图",
        class: "图",
        loading: "lazy"
      }, null, 8, _hoisted_12), _createElementVNode("img", {
        src: _unref(成长),
        alt: "成长",
        class: "成长",
        loading: "lazy"
      }, null, 8, _hoisted_13), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑6",
        loading: "lazy"
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线6",
        loading: "lazy"
      }, null, 8, _hoisted_15)])]);
    };
  }
};